var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddkeyframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1386_14",
    "data-name": "Component 1386 \\u2013 14",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.53,
    height: 12,
    viewBox: "0 0 10.53 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2026",
    "data-name": "Rectangle 2026",
    width: 6.897,
    height: 6.897,
    transform: "translate(4.877 2.247) rotate(45)",
    fill: "#203662"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20861",
    "data-name": "Path 20861",
    d: "M2.578-5.608H4.055v.495H2.578v1.527h-.5V-5.113H.609v-.495h1.47V-7.143h.5Z",
    transform: "translate(6.476 7.143)",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddkeyframe);
export default __webpack_public_path__ + "static/media/Add keyframe.a3fa90242b1b317112095e0e397f25d0.svg";
export { ForwardRef as ReactComponent };